const INIT = { messages: {} };

export default function errorReducer(state = INIT, action) {
  const match = /(.*)_(REQUEST|SUCCESS|ERROR)/.exec(action.type);
  if (!match) return state;
  const [, requestName, status] = match;
  if (status === 'ERROR') {
    const msg = action.payload?.error?.message || 'An error occurred';
    return { ...state, messages: { ...state.messages, [requestName]: msg } };
  }
  if (status === 'REQUEST' || status === 'SUCCESS') {
    const { [requestName]: _, ...rest } = state.messages;
    return { ...state, messages: rest };
  }
  return state;
}

export const createErrorMessageSelector = (actions) => (state) => {
  for (const a of actions) {
    const msg = state.api.error.messages[a.ACTION];
    if (msg) return msg;
  }
  return null;
};
